module.exports = __webpack_public_path__ + "img/app-blue.93a02266.svg";